export default {
	login: {
		title: 'Login',
		metaTitle: 'Login to {{brandName}}',
		description: {
			line1: 'Enter your email or username and password to',
			line2: 'Log into your account',
		},
		usernameLabel: 'Username',
		usernameOrEmailLabel: 'Username or email',
		passwordLabel: 'Password',
		emailPlaceholder: 'name@example.com',
		usernameOrEmailPlaceholder: 'name@example.com or your_username',
		rememberMe: 'Remember me',
		forgotPasswordLink: 'Forgot password?',
		submit: 'Log in',
		newHere: 'New here?',
		signupLink: 'Create an account',
		legalNotice: {
			prefix: 'By clicking login, you agree to our',
			termsLink: 'Terms of Service',
			connector: 'and',
			privacyLink: 'Privacy Policy',
			suffix: '.',
		},
		passkey: {
			loginWithPasskey: 'Login with a passkey',
			generatingAuthOptions: 'Generating authentication options',
			requestingAuthorization: 'Requesting your authorization',
			verifyingPasskey: 'Verifying your passkey',
			loggedInNavigating: "You're logged in! Navigating...",
			unknownError: 'Unknown error',
			failedToAuthenticate: 'Failed to authenticate with passkey: {{error}}',
		},
	},
	signup: {
		title: 'Start free',
		metaTitle: 'Sign up | {{brandName}}',
		description: "Enter your email and we'll send you a verification code.",
		alreadyHaveAccount: 'Already have an account?',
		signIn: 'Sign in',
		emailLabel: 'Email',
		emailHint:
			'We will send you a link and a code. Also check spam or promotions.',
		submit: 'Send access code',
		emailExistsLoginLink: 'Sign in with this email',
		legalNotice: {
			prefix: 'By creating an account, you agree to our',
			termsLink: 'Terms of Service',
			connector: 'and',
			privacyLink: 'Privacy Policy',
			suffix: '.',
		},
		emailSubject: 'Welcome to {{brandName}}!',
		emailHeading: 'Welcome to {{brandName}}!',
		verificationCode: "Here's your verification code:",
		clickToStart: 'Or click the link to get started:',
	},
	forgotPassword: {
		title: 'Forgot password',
		metaTitle: 'Password recovery for {{brandName}}',
		description: {
			line1: 'Enter your registered email or username and',
			line2: 'We will send you a link to reset your password.',
		},
		usernameOrEmailLabel: 'Username or email',
		submit: 'Recover password',
		dontHaveAccount: "Don't have an account?",
		signup: 'Sign up',
		emailSubject: '{{brandName}} password reset',
		emailHeading: '{{brandName}} password reset',
		verificationCode: "Here's your verification code:",
		clickLink: 'Or click the link:',
	},
	resetPassword: {
		title: 'Password reset',
		metaTitle: 'Reset password | {{brandName}}',
		greeting: 'Hi, {{username}}. No worries. It happens all the time.',
		newPasswordLabel: 'New password',
		confirmPasswordLabel: 'Confirm password',
		submit: 'Reset password',
	},
	verify: {
		title: 'Two-factor authentication',
		metaTitle: 'Two-factor authentication | {{brandName}}',
		description:
			'Please enter the authentication code we have sent to your email.',
		checkEmailTitle: 'Check your email',
		checkEmailDescription:
			'We sent it to your email. The link and the code expire in 10 minutes. Check spam or promotions if it does not arrive.',
		resetPasswordLinkDescription:
			"We've sent you a password reset link. Open it from your email to create a new password.",
		check2FATitle: 'Check your 2FA app',
		check2FADescription: 'Please enter your 2FA code to verify your identity.',
		codeLabel: 'Code',
		crossDeviceHint:
			'You can open the link or copy the code and enter it here.',
		resetPasswordLinkOnlyHint:
			'If the link was opened on another device or has expired, request a new password reset email and use the reset button in that email.',
		submit: 'Verify',
		processingTitle: 'Verifying your link...',
		processingDescription: 'Please wait while we complete your verification.',
		notReceived: "Haven't received it?",
		resend: 'Resend a new code',
		resendResetLink: 'Send a new reset link',
		resendCountdown: 'Resend in {{seconds}} s',
		resendSuccess: 'Code resent. Check your email.',
		resendError: 'We could not resend the code. Try again.',
		startOver: 'Start over',
	},
	onboarding: {
		setupTitle: 'Setup {{brandShortName}} account',
		title: 'Welcome aboard {{email}}!',
		description: 'Finish these details to save your progress.',
		usernameLabel: 'Username',
		usernameHint:
			'We suggested one from your email. Use 3 to 20 characters: letters, numbers, and underscores.',
		usernameSuggestionsLabel: 'Try one of these options:',
		nameLabel: 'Name',
		passwordLabel: 'Password',
		channelLabel: 'How did you hear about {{brandName}}? (optional)',
		channelPlaceholder: 'Prefer not to say',
		channelOptions: {
			search: 'A search engine',
			delegation_or_school: 'My student association or school',
			teacher: 'A teacher',
			social: 'Social media',
			friend: 'A friend',
			other: 'Other',
		},
		confirmPasswordLabel: 'Confirm password',
		passwordRequirements: {
			title: 'Password requirements',
			minLength: 'At least 6 characters',
			maxLength: 'Short enough for secure storage',
			match: 'Both passwords match',
		},
		termsLabel: {
			prefix: 'I accept the',
			termsLink: 'Terms of Service',
			connector: 'and the',
			privacyLink: 'Privacy Policy',
			suffix: '.',
		},
		rememberMe: 'Remember me',
		createAccount: 'Create an account',
		youCanChangePhoto: 'You can change your photo later',
		alt: {
			profile: 'Profile',
		},
		welcomeToastTitle: 'Welcome',
		welcomeToastDescription: 'Thanks for signing up!',
	},
	errors: {
		invalidCredentials: 'Invalid username, email, or password',
		usernameRequired: 'Username is required',
		usernameTooShort: 'Username must be at least 3 characters',
		usernameTooLong: 'Username cannot exceed 20 characters',
		usernameInvalidFormat:
			'Username can only include letters, numbers, and underscores',
		emailRequired: 'Enter your email to continue',
		emailInvalid: 'Check the format: name@example.com',
		emailTooShort: 'Email is too short',
		emailTooLong: 'Email is too long',
		passwordRequired: 'Password is required',
		passwordTooShort: 'Password is too short',
		passwordTooLong: 'Password is too long',
		passwordsMustMatch: 'The passwords must match',
		nameRequired: 'Name is required',
		nameTooShort: 'Name is too short',
		nameTooLong: 'Name is too long',
		emailExists: 'A user already exists with this email',
		usernameExists: 'A user already exists with this username',
		userNotFound: 'No user exists with this username or email',
		passwordTooCommon: 'Password is too common',
		mustAgree: 'You must agree to the terms of service and privacy policy',
	},
}
